import type { OperationsNodeType } from '../types/operations.types'

/**
 * The i18n key naming each node type, so an action label can read "Edit Team"
 * or "Delete Division" rather than a bare "Edit" / "Delete". Keeping the map
 * here means the tree rail, the teams grid and the divisions grid cannot drift
 * apart on wording.
 */
export const NODE_TYPE_KEY: Record<OperationsNodeType, string> = {
  season: 'common:season',
  conference: 'common:conference',
  division: 'common:division',
  team: 'common:team',
}

export type NodeActionKind = 'edit' | 'delete' | 'move'

const ACTION_KEY: Record<NodeActionKind, string> = {
  edit: 'common:editEntity',
  delete: 'common:deleteEntity',
  move: 'common:moveEntity',
}

type Translate = (key: string, options?: unknown) => string

/**
 * Builds "Edit Team" / "Delete Division" for a node type. Framework-agnostic —
 * the translator is injected so `common/` stays free of an i18n import and this
 * stays trivially testable.
 */
export const nodeActionLabel = (
  action: NodeActionKind,
  type: OperationsNodeType,
  translate: Translate
): string =>
  translate(ACTION_KEY[action], { entity: translate(NODE_TYPE_KEY[type]) })
